import { computed, readonly, ref } from 'vue'

import { useConversationAndMessages } from '@/messages/services'
import { useIntegerRouteParam } from '@/utils/composables'
import { defineService } from '@/utils/datastore/helpers'

import { useIssueDetailQuery } from './queries'

export const useActiveIssueService = defineService(() => {
  const preloadIssueId = ref(null)
  const routeParamIssueId = useIntegerRouteParam('issueId')
  const issueId = computed(() => routeParamIssueId.value ?? preloadIssueId.value)

  const {
    issue,
    wait: waitForIssueToLoad,
  } = useIssueDetailQuery({ issueId })

  async function preloadIssue (id) {
    preloadIssueId.value = id
    await waitForIssueToLoad()
    return issue.value
  }

  const {
    conversation,
    messages,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useConversationAndMessages(
    { issueId },
    // TODO: should issue messages be this way or oldest-first?
    { order: 'newest-first' },
  )

  return {
    preloadIssue,
    issueId: readonly(issueId),
    issue,
    waitForIssueToLoad,
    conversation,
    messages,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  }
})
